import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';

import {SearchRequest, SearchResponse} from '../model/model';

@Injectable()
export class SearchRepository {

  constructor(
    private http: HttpClient,
    private authRequest: AuthRequest,
  ) { }

  public getSearchResults(request: SearchRequest): Observable<SearchResponse> {
    return this.authRequest.handleRequest(
      this.http.post(environment.search.searchRoute, request, {withCredentials: true}))
      .pipe(map((response) => { return <SearchResponse> response; }));
  }


}
